import MonacoEditor from "@monaco-editor/react";

interface MarkdownEditorProps {
  value: string;
  onChange: (value: string | undefined) => void;
  readOnly: boolean;
  onMount: (editor: any) => void;
}

/** Monaco markdown editor with the settings shared by every editor surface in the template builder. */
const MarkdownEditor = ({ value, onChange, readOnly, onMount }: MarkdownEditorProps) => {
  return (
    <>
      <MonacoEditor
        height="100%"
        defaultLanguage="markdown"
        value={value}
        onChange={onChange}
        theme="vs-light"
        options={{
          fontSize: 14,
          minimap: { enabled: false },
          scrollBeyondLastLine: false,
          wordWrap: "on",
          wrappingIndent: "same",
          formatOnPaste: true,
          formatOnType: true,
          lineNumbers: "on",
          renderWhitespace: "selection",
          renderLineHighlight: "all",
          automaticLayout: true,
          readOnly,
          scrollbar: {
            vertical: "auto",
            horizontal: "auto",
            verticalScrollbarSize: 8,
            horizontalScrollbarSize: 8,
          },
          contextmenu: false,
          quickSuggestions: false,
          parameterHints: { enabled: false },
          hover: { enabled: false },
        }}
        onMount={onMount}
      />
      <style>{`
        .search-highlight {
          background: #1976d2 !important;
          color: #fff !important;
          borderRadius: 2px;
        }
      `}</style>
    </>
  );
};

export default MarkdownEditor;
